<ng-container *transloco="let t">
  <div
    (click)="$event.stopPropagation(); openInfo()"
    class="cursor-pointer text-end"
    data-toggle="tooltip"
    data-placement="bottom"
    matTooltip="{{ t('inventory-table.number_activated_strategies', { count: strategyList.length }) }}"
  >
    {{ strategyList.length }}
  </div>
</ng-container>
